import React, { useState, useEffect } from "react";
import { Card, CardContent, Typography, LinearProgress, Box, Grid, Divider } from '@mui/material';
import LoopIcon from '@mui/icons-material/Loop';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import EmployeeNeedForm from "../Forms/EmployeeNeedForm";

const EmployeeNeedCard = (props) => {
    const [open, setOpen] = useState(false);
    
    const handleClose = () => setOpen(false);
    const handleSubmit = (needs) => {
        props.setEmployeeNeeds(needs);
    };

    return (
        <Box>
            <Card variant="outlined" style={{ borderRadius: '10px' }}>
                <CardContent>
                    <Grid container spacing={2} alignItems="center">
                        <Grid size={{ xs: 12, md: 9 }}>
                            <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                                <Typography variant="h5" component="div" >
                                    Employee Needs
                                </Typography>
                                <IconButton sx={{ mr : 1 }} onClick={() => setOpen(true)}>
                                    <EditIcon />
                                </IconButton>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, md: 3 }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Typography variant="h6" component="div" display="inline" sx={{ marginRight: '5px' }}>
                                    Status: {props.employeeNeeds?.employment_first_plan && props.employeeNeeds?.employment_plan && props.employeeNeeds?.voting_plan ? 'Completed' : 'Not Completed'}
                                </Typography>
                                {props.employeeNeeds?.employment_first_plan && props.employeeNeeds?.employment_plan && props.employeeNeeds?.voting_plan ? <CheckCircleOutlineIcon sx={{ color: '#3fa7d6' }} fontSize="large" /> : <LoopIcon sx={{ color: '#3fa7d6' }} fontSize="large" />}
                            </div>
                        </Grid>
                        <Grid size={12}>
                            <Divider />
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1" component="div" sx={{ marginRight: '5px' }}>
                                Employee First implementation: {props.employeeNeeds?.employment_first_plan ? <CheckCircleOutlineIcon sx={{ color: '#3fa7d6' }} /> : <LoopIcon sx={{ color: '#3fa7d6' }} />}
                            </Typography>
                            {props.employeeNeeds?.employment_first_plan ? 
                                <Typography variant="body2" component="div" sx={{ marginLeft: '20px', whiteSpace: 'pre-line' }}>{props.employeeNeeds?.employment_first_plan}</Typography> :
                                ''
                            }
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1" component="div" sx={{ marginRight: '5px' }}>
                                Employment Plan: {props.employeeNeeds?.employment_plan ? <CheckCircleOutlineIcon sx={{ color: '#3fa7d6' }} /> : <LoopIcon sx={{ color: '#3fa7d6' }} />}
                            </Typography>
                            {props.employeeNeeds?.employment_plan ? 
                                <Typography ariant="body2" component="div" sx={{ marginLeft: '20px', whiteSpace: 'pre-line' }}>{props.employeeNeeds?.employment_plan}</Typography> :
                                ''
                            }
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1" component="div" sx={{ marginRight: '5px' }}>
                                Voting Plan: {props.employeeNeeds?.voting_plan ? <CheckCircleOutlineIcon sx={{ color: '#3fa7d6' }} /> : <LoopIcon sx={{ color: '#3fa7d6' }} />}
                            </Typography>
                            {props.employeeNeeds?.voting_plan ? 
                                <Typography ariant="body2" component="div" sx={{ marginLeft: '20px', whiteSpace: 'pre-line' }}>{props.employeeNeeds?.voting_plan}</Typography> :
                                ''
                            }
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            <EmployeeNeedForm
                open={open}
                handleClose={handleClose}
                handleSubmit={handleSubmit}
                employeeNeeds={props.employeeNeeds}
                setEmployeeNeeds={props.setEmployeeNeeds}
                customer_id={props.customer_id}
            />
        </Box>
    );
}

export default EmployeeNeedCard;